class Assets {

    transformColors(colors) {
        let clonedColors = JSON.parse(JSON.stringify(colors));

        return _.map(clonedColors, (color) => {
            color.id = color.id.toString();
            color.brand = "prolook";
            color.hex_code = color.web_hex_code;
            color.alias = color.color_alias;
            color.name = color.color_alias;
            color.order = ub.data.sublimatedColorArrangement.getOrderID(color.name).order;
            return color;
        });
    }

    transformAccents(accents) {
        let results = [];
        accents && (results = JSON.parse(accents));
        return results;
    }

    transformFabrics(fabrics) {
        let fabricArr = [];

        if (_.size(fabrics) > 0) {
            _.each(fabrics, fabric => {
                let fabricColors = _.first(fabric.colors);
                
                if (_.isUndefined(fabricColors)) return;

                fabric.colors = this.getColors(JSON.parse(fabricColors.color_codes));

                fabricArr.push(fabric);
            })
        }

        return fabricArr;
    }

    processFonts(fontData, callback) {
        let fonts = [];
        let fontSettings = [];

        _.each(fontData, font => {
            if (font.name === "") {
                return;
            }

            font.caption = font.alias;
            var _fontSizeTables = font.font_size_tables;
            var _sublimatedFontSizeTables = font.sublimated_font_size_tables;
            var _parsedFontSizeTables = undefined;
            var _parsedSublimatedFontSizeTables = undefined;

            if (typeof _fontSizeTables !== "undefined" && _fontSizeTables !== null && _fontSizeTables !== "") {
               _parsedFontSizeTables = JSON.parse(_fontSizeTables);
            }

            if (typeof _sublimatedFontSizeTables !== "undefined" && _sublimatedFontSizeTables !== null && _sublimatedFontSizeTables !== "") {
                _parsedSublimatedFontSizeTables = JSON.parse(_sublimatedFontSizeTables);
            }

            if (ub.config.uniform_application_type === "sublimated") {
                _parsedFontSizeTables = _parsedSublimatedFontSizeTables;
            }

            var enableFontRules = ub.funcs.enableFontRules(ub.config.brand, ub.user.id, ub.config.sport);

            // PL2.5 new feature
            // use sublimated font properties regardless if it is twill or sublimated style
            if (enableFontRules) {
                _parsedFontSizeTables = _parsedSublimatedFontSizeTables;
            }

            fontSettings.push({
                id: font.id.toString(),
                name: font.name,
                parsedFontSizeTables: _parsedFontSizeTables,
                sublimatedParsedFontSizeTables: _parsedSublimatedFontSizeTables,
                font_size_tables: font.font_size_tables,
                sublimated_font_size_tables: font.sublimated_font_size_tables,
                font_properties: font.font_properties
            });

            fonts.push({
                id: font.id.toString(),
                name: font.name,
                font_path: font.font_path,
                type: font.type,
                active: font.active,
                sports: font.sports,
                alias: font.alias,
                caption: font.caption,
                is_new: font.new_font
            });
        })

        // Assign in ub.data.fonts

        callback({
            fonts,
            fontSettings
        })
    }

    getColors(colorCodes) {
        let colors = [];
        let availableColors = _.size(QX7Rule.colors) > 0 ? QX7Rule.colors : ub.data.colors

        if (_.size(colorCodes) <= 0) {
            console.warn("No available color sets.")
        }

        _.each(colorCodes, code => {
            let colorObject = _.find(availableColors, {color_code: code});

            if (_.isUndefined(colorObject)) return;

            colors.push(colorObject);
        })

        return colors;
    }
}
